import { Component, OnInit, ViewChild } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-flags',
  templateUrl: './flags.page.html',
  styleUrls: ['./flags.page.scss'],
})
export class FlagsPage implements OnInit {

  paises: any = []

  constructor(
    private popoverCtrl: PopoverController
  ) { }

  ngOnInit() {

    this.paises = [
      {
        pais: 'cl',
        nombre: 'CHILE',
        flag: '/assets/flags/cl.svg'
      },
      {
        pais: 'co',
        nombre: 'COLOMBIA',
        flag: '/assets/flags/co.svg'
      },
      {
        pais: 'cr',
        nombre: 'COSTARICA',
        flag: '/assets/flags/cr.svg'
      },
      {
        pais: 'ec',
        nombre: 'ECUADOR',
        flag: '/assets/flags/ec.svg'
      },
      {
        pais: 'es',
        nombre: 'ESPAÑA',
        flag: '/assets/flags/es.svg'
      },
      {
        pais: 'mx',
        nombre: 'MEXICO',
        flag: '/assets/flags/mx.svg'
      },
      {
        pais: 'pa',
        nombre: 'PANAMA',
        flag: '/assets/flags/pa.svg'
      },
      {
        pais: 'pe',
        nombre: 'PERU',
        flag: '/assets/flags/pe.svg'
      },
      {
        pais: 'pr',
        nombre: 'PUERTO RICO',
        flag: '/assets/flags/pr.svg'
      },

    ];
  }

  escogerPais(ev) {
    this.dismiss(ev);
  }

  dismiss(pais) {
     this.popoverCtrl.dismiss(pais);
  }
}